import { fetchActionRequiredJobs, fetchOpenJobs, fetchScheduledJobs } from '../../../actions';
import {
  CalendarActionNeededFilterIcon,
  CalendarOpenFilterIcon,
  CalendarTodayFilterIcon,
} from '../../../images/emptyScreenIcons';
import { CONFIRM_CANDIDATE_LABEL, FilterStatusEnum } from '../../../utils/Enum';

export const headerOpenTabTitles = ['Office', 'Shift Details', 'Profession', 'Rate', 'Send to'];

export const headerPendingTabTitles = [
  'Office',
  'Shift Details',
  'Profession',
  'Candidates',
  'Send to',
  'More',
];

export const headerScheduledTabTitles = [
  'Office',
  'Professional',
  'Shift Details',
  'Profession',
  'Rate',
];

export const getInitialTab = (type) => {
  if (type === FilterStatusEnum.PENDING) return 'pending';
  // FilterStatusEnum.SCHEDULED = 'filled'; URL param is 'scheduled' — accept both
  if (type === FilterStatusEnum.SCHEDULED || type === 'scheduled') return 'scheduled';
  return 'open';
};

export const getTypeByTab = (activeTab) => {
  if (activeTab === 'pending') return FilterStatusEnum.PENDING;
  if (activeTab === 'scheduled') return FilterStatusEnum.SCHEDULED;
  return FilterStatusEnum.OPEN;
};

export const fetchJobList = (type, data) => {
  switch (type) {
    case FilterStatusEnum.OPEN:
      return fetchOpenJobs(data);
    case FilterStatusEnum.PENDING:
      return fetchActionRequiredJobs(data);
    case FilterStatusEnum.SCHEDULED:
      return fetchScheduledJobs(data);
    default:
      return () => {};
  }
};

export const getEmptyFilteredScreen = (filter) => {
  switch (filter) {
    case FilterStatusEnum.SCHEDULED:
      return {
        title: 'Ready to schedule your next candidate!',
        description: (
          <>
            You have no candidates scheduled.
            <br />
            Click on the “{CONFIRM_CANDIDATE_LABEL}” tab to see if any
            <br />
            candidates have applied to your posted shifts!
          </>
        ),
        Icon: CalendarTodayFilterIcon,
      };
    case FilterStatusEnum.PENDING:
      return {
        title: 'Waiting for candidates to apply!',
        description: (
          <>
            No professionals have applied to your shifts yet.
            <br />
            Check back soon, someone might apply at any moment!
          </>
        ),
        Icon: CalendarActionNeededFilterIcon,
      };
    default:
      return {
        title: 'Post shifts, let us help you!',
        description: (
          <>
            You have not created any shifts.
            <br />
            Post a shift, to find the right professionals and
            <br />
            secure the coverage you need!
          </>
        ),
        buttonText: 'Post Shifts!',
        buttonLink: '/dashboard/multi-day/info',
        Icon: CalendarOpenFilterIcon,
      };
  }
};
